export const dramaGenres = [
  "全部",
  "悬疑惊悚",
  "浪漫爱情",
  "青春治愈",
  "古装奇幻",
  "家庭生活",
  "复仇爽剧",
  "犯罪黑色",
];

export const dramas = [
  {
    id: "squid-game",
    title: "鱿鱼游戏",
    genre: "悬疑惊悚",
    year: "2021",
    tags: ["生存游戏", "群像博弈", "高概念"],
    summary:
      "一群背负债务的普通人被卷入神秘游戏，用生命作为筹码争夺巨额奖金。剧情用极简规则堆叠层层压迫感，人物在绝境中的选择成为最大看点。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20survival%20thriller%20drama%20poster%20art%2C%20silhouettes%20of%20players%20on%20an%20abstract%20geometric%20staircase%20platform%2C%20warm%20amber%20and%20deep%20coral%20lighting%2C%20dramatic%20shadows%2C%20simple%20stylized%20background%2C%20film%20still%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hdrama-poster-01&orientation=portrait",
  },
  {
    id: "crash-landing",
    title: "爱的迫降",
    genre: "浪漫爱情",
    year: "2019",
    tags: ["反差设定", "跨越边界", "笑泪并重"],
    summary:
      "财阀千金在一次滑翔伞事故后意外降落异乡，与当地军官相遇相知。身份与环境的巨大反差支撑起整段感情线，甜度与细腻并存。",
    image:
      "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20poster%20art%2C%20a%20couple%20standing%20under%20soft%20glowing%20lanterns%20at%20night%2C%20warm%20amber%20and%20coral%20tones%2C%20dreamy%20bokeh%20lights%2C%20minimal%20simple%20background%2C%20cinematic%20film%20still%20aesthetic%2C%20tender%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hdrama-poster-02&orientation=portrait",
  },
  {
    id: "twenty-five",
    title: "二十五，二十一",
    genre: "青春治愈",
    year: "2022",
    tags: ["时代记忆", "成长阵痛", "细腻情绪"],
    summary:
      "世纪之交的动荡年代，两个年轻人因时代与家庭而相遇、靠近又错开。剧集用大量细节还原九十年代的氛围，把青春的莽撞与遗憾讲得很真。",
    image:
      "https://readdy.ai/api/search-image?query=Nostalgic%20coming%20of%20age%20Korean%20drama%20poster%20art%2C%20two%20young%20people%20in%20vintage%20nineties%20clothing%20on%20a%20sunny%20street%2C%20warm%20amber%20and%20soft%20cream%20tones%2C%20gentle%20sunlight%2C%20simple%20minimal%20background%2C%20film%20still%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hdrama-poster-03&orientation=portrait",
  },
  {
    id: "the-glory",
    title: "黑暗荣耀",
    genre: "复仇爽剧",
    year: "2022",
    tags: ["缜密复仇", "冷调叙事", "人物立体"],
    summary:
      "校园暴力受害者成年后以一位教师的身份重新接近加害者，用漫长而克制的方式布局复仇。节奏稳、镜头冷，爽感与沉重感同时拉满。",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20revenge%20Korean%20drama%20poster%20art%2C%20a%20lone%20figure%20standing%20in%20a%20long%20corridor%20with%20warm%20amber%20side%20light%2C%20deep%20coral%20shadows%2C%20minimal%20abstract%20background%2C%20tense%20cinematic%20film%20still%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hdrama-poster-04&orientation=portrait",
  },
  {
    id: "hospital-playlist",
    title: "机智的医生生活",
    genre: "家庭生活",
    year: "2020",
    tags: ["温暖群像", "生活流", "乐队日常"],
    summary:
      "五位医生好友在医院里救死扶伤，也在乐队排练和生活琐碎中互相打气。没有大起大落，却用生活流叙事把友情与日常拍得格外治愈。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20healing%20Korean%20drama%20poster%20art%2C%20five%20friends%20smiling%20around%20a%20rehearsal%20room%20with%20musical%20instruments%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20indoor%20lighting%2C%20simple%20minimal%20background%2C%20film%20still%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hdrama-poster-05&orientation=portrait",
  },
  {
    id: "kingdom",
    title: "王国",
    genre: "古装奇幻",
    year: "2019",
    tags: ["古装惊悚", "权谋线", "场面宏大"],
    summary:
      "古代宫廷背景下疫病蔓延，王储一边查明真相一边对抗夺权的门阀势力。古装与惊悚元素结合，权谋线扎实，群戏与场面调度都很出色。",
    image:
      "https://readdy.ai/api/search-image?query=Historical%20Korean%20drama%20poster%20art%2C%20a%20crown%20prince%20in%20traditional%20royal%20robes%20before%20misty%20palace%20walls%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20atmospheric%20fog%2C%20minimal%20stylized%20background%2C%20cinematic%20film%20still%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hdrama-poster-06&orientation=portrait",
  },
  {
    id: "reply-1988",
    title: "请回答1988",
    genre: "青春治愈",
    year: "2015",
    tags: ["年代怀旧", "亲情邻里", "群像鲜活"],
    summary:
      "首尔老巷子里五个家庭的故事，围绕一群少年的成长和邻里间的扶持展开。台词平实却戳人，把青春、亲情与时代变迁拍得细致入微。",
    image:
      "https://readdy.ai/api/search-image?query=Nostalgic%20eighties%20Korean%20drama%20poster%20art%2C%20neighbors%20gathered%20in%20a%20small%20old%20alley%20at%20dusk%2C%20warm%20amber%20and%20soft%20cream%20tones%2C%20cozy%20evening%20light%2C%20simple%20minimal%20background%2C%20film%20still%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hdrama-poster-07&orientation=portrait",
  },
  {
    id: "itaewon-class",
    title: "梨泰院Class",
    genre: "复仇爽剧",
    year: "2020",
    tags: ["热血逆袭", "坚持原则", "节奏紧凑"],
    summary:
      "青年因不肯低头而退学入狱，出狱后从零开始创业，一步步向财团反击。剧集主打热血的逆袭节奏，也把坚持与成长讲得有分量。",
    image:
      "https://readdy.ai/api/search-image?query=Energetic%20youth%20Korean%20drama%20poster%20art%2C%20a%20determined%20young%20man%20on%20a%20neon%20lit%20city%20street%20at%20night%2C%20warm%20amber%20and%20coral%20tones%2C%20dynamic%20lighting%2C%20simple%20minimal%20background%2C%20cinematic%20film%20still%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hdrama-poster-08&orientation=portrait",
  },
  {
    id: "vincenzo",
    title: "文森佐",
    genre: "犯罪黑色",
    year: "2021",
    tags: ["黑色幽默", "反差人设", "智斗动作"],
    summary:
      "海外黑手党顾问回到韩国，用各种非常规手段与财团对抗。黑色幽默和硬核智斗交替出现，反差人设让整部剧又燃又好笑。",
    image:
      "https://readdy.ai/api/search-image?query=Sleek%20crime%20Korean%20drama%20poster%20art%2C%20a%20man%20in%20a%20sharp%20dark%20suit%20walking%20through%20a%20moody%20city%20alley%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20dramatic%20shadows%2C%20minimal%20stylized%20background%2C%20film%20still%20aesthetic%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hdrama-poster-09&orientation=portrait",
  },
];